import AnimatedImageSection from '../components/AnimatedImageSection';
import { landingSections } from '../data/landingSections';
import './LandingPage.css';

function LandingPage({ onInquiry }) {
  return (
    <main className="landing">
      {landingSections.map((section) => (
        <AnimatedImageSection
          key={section.src}
          section={section}
          onInquiry={onInquiry}
        />
      ))}
    </main>
  );
}

export default LandingPage;
